// extracted by mini-css-extract-plugin
export default {"parentView":"style_parentView__fhwp8","headerView":"style_headerView__tLLV6","contentsView":"style_contentsView__WeBn3","space1X":"style_space1X__kEh-c"};